import { jsxs as i, jsx as s } from "react/jsx-runtime";
import _ from "react";
import { F as p } from "../../Combination-Dp_plIQU.js";
import { Button as h } from "../Button/Button.js";
import { Interactive as f } from "../Interactive/Interactive.js";
import { I as u } from "../../Icons-NE1cibCU.js";
import { clsx as l } from "../../utils/clsx.js";
import { noop as v } from "../../utils/functional.js";
import { useOutlet as b, useKeyboardClose as z } from "../../utils/hooks.js";
import '../../assets/Flyout.css';const N = "_root_11ks7_1", C = "_holder_11ks7_6", y = "_active_11ks7_15", F = "_backdrop_11ks7_15", x = "_mask_11ks7_28", I = "_content_11ks7_90", L = "_header_11ks7_95", O = "_title_11ks7_101", e = {
  root: N,
  "size-normal": "_size-normal_11ks7_6",
  holder: C,
  "size-small": "_size-small_11ks7_9",
  "size-xsmall": "_size-xsmall_11ks7_12",
  active: y,
  backdrop: F,
  "backdrop-appearance": "_backdrop-appearance_11ks7_1",
  mask: x,
  "holder-appearance": "_holder-appearance_11ks7_1",
  content: I,
  header: L,
  title: O
}, E = "flyout-outlet";
function T(c) {
  const {
    disabled: o = !1,
    size: a = "normal",
    onClose: r = v,
    children: n,
    holderClassName: d
  } = c, m = b(E);
  _.useEffect(() => {
    if (o)
      return;
    const t = document.getElementById("cfxui-root");
    return t == null || t.classList.add("shrink"), () => t == null ? void 0 : t.classList.remove("shrink");
  }, [o]), z(r);
  const k = l(e.root, e[`size-${a}`], {
    [e.active]: !o
  });
  return /* @__PURE__ */ s(m, { children: /* @__PURE__ */ i("div", { className: k, children: [
    /* @__PURE__ */ s(f, { showPointer: !1, className: e.backdrop, onClick: r }),
    /* @__PURE__ */ s("div", { className: e.mask, children: /* @__PURE__ */ s("div", { className: l(e.holder, d), children: /* @__PURE__ */ s(p, { disabled: !!o, className: e.content, children: n }) }) })
  ] }) });
}
T.Header = _.forwardRef(function(o, a) {
  const {
    onClose: r,
    children: n
  } = o;
  return /* @__PURE__ */ i("div", { ref: a, className: e.header, children: [
    /* @__PURE__ */ s("div", { className: e.title, children: n }),
    !!r && /* @__PURE__ */ s(h, { size: "large", icon: u.exit, onClick: r })
  ] });
});
export {
  E as FLYOUT_OUTLET_ID,
  T as Flyout
};
